<template>
    <div>
        <b-navbar fixed="top" type="dark" class="navbar-bg py-0 px-0">
            <AlertBrowserIE />
            <b-navbar-brand class="cursor-pointer div-brand py-3" href="/">
                <img src="../assets/immagini/cvaenergie-logo.svg" class="cvalogo">
            </b-navbar-brand>
        </b-navbar>
    </div>
</template>

<script>
import AlertBrowserIE from '@/components/AlertBrowserIE.vue'
export default {
  name: 'Navbar',
  components: {
    AlertBrowserIE,
  },
}
</script>
